import { DiscountUpdateEvent } from '@theme/events';

const dialog = document.querySelector('[data-fnk-welcome-v2]');
if (dialog) {
  const [api, { createChainMedia, prefersChainImages }, { canAutoShowWelcome }] = await Promise.all([
    import(dialog.dataset.apiUrl), import(dialog.dataset.mediaUrl), import(dialog.dataset.triggerUrl),
  ]);
  const preview = ['localhost', '127.0.0.1'].includes(location.hostname) && dialog.dataset.preview === 'true';
  const trackEvent = api.createWelcomeV2Tracker(window, ['localhost', '127.0.0.1'].includes(location.hostname) || window.Shopify?.designMode === true);
  const track = (stage, context = {}) => trackEvent(stage, { ...context, offer: dialog.dataset.offerContext || 'generic' });
  const teaser = document.querySelector('[data-fnk-offer-teaser] button');
  const teaserRoot = teaser?.closest('[data-fnk-offer-teaser]');
  const teaserLabel = teaser?.querySelector('.fnk-offer-teaser__label');
  const emailForm = dialog.querySelector('[data-welcome-form="email"]');
  const smsForm = dialog.querySelector('[data-welcome-form="sms"]');
  const key = 'fnk-welcome-v2';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const motionButton = dialog.querySelector('[data-welcome-motion]');
  let state = api.restoreWelcomeV2State();
  let email = '';
  let smsRequestId;
  let smsIdentity = '';
  let lastSmsEvent;
  let resendEvent;
  let resendDeadline = 0;
  let resendTimer;
  let recovery = false;
  const resendButton = dialog.querySelector('[data-welcome-resend]');
  const changePhoneButton = dialog.querySelector('[data-welcome-change-phone]');
  const resendStatus = dialog.querySelector('[data-welcome-resend-status]');
  const smsDiscountStatus = dialog.querySelector('[data-welcome-sms-discount]');
  const applySmsButton = dialog.querySelector('[data-welcome-apply-sms]');
  let applyingEmailDiscount = false;
  const applyWelcomeDiscount = api.createWelcomeDiscountApplier({ emailCode: dialog.dataset.emailCode, smsCode: dialog.dataset.smsCode, root: dialog.dataset.root });
  const offerCopy = api.createWelcomeOfferCopy(dialog, { root: dialog.dataset.root, welcomeCodes: [dialog.dataset.emailCode, dialog.dataset.smsCode, 'FNKFAM10', 'FNK10'], onChange: cart => {
    syncTeaser();
    if (!applyingEmailDiscount) api.renderWelcomeEmailDiscount(dialog, cart);
  } });
  offerCopy.refresh();
  document.addEventListener('cart:update', () => offerCopy.refresh());
  document.addEventListener('discount:update', () => offerCopy.refresh());
  let applyingSmsDiscount = false;
  let busy = false;
  let opening = false;
  let closing = false;
  let paused = reducedMotion.matches;
  let lastFocused;
  let returnCart;
  let shown = false;
  let previousY = scrollY;
  let hasScrolled = false;
  let frame;
  let toastTimer;
  let trigger = 'teaser';
  let entry = 'new';
  if (!preview) {
    try { state = api.restoreWelcomeV2State(JSON.parse(localStorage.getItem(key) || '{}')); } catch {}
    save();
    try { shown = sessionStorage.getItem(`${key}-shown`) === 'true'; } catch {}
    if (state.emailAccepted && !state.smsAccepted) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(`${key}-email`) || '{}');
        const age = Date.now() - Number(saved.acceptedAt);
        if (age >= 0 && age < 86400000) email = api.normalizeWelcomeEmail(saved.email);
        else sessionStorage.removeItem(`${key}-email`);
      } catch { try { sessionStorage.removeItem(`${key}-email`); } catch {} }
    } else { try { sessionStorage.removeItem(`${key}-email`); } catch {} }
  }
  const media = createChainMedia({
    products: [...dialog.querySelectorAll('[data-chain-product]')],
    interval: 1500,
    canPlay: () => dialog.open && dialog.dataset.step === 'email' && !paused && !document.hidden && !closing,
    imagesOnly: prefersChainImages(navigator.userAgent),
    onMode: mode => { dialog.dataset.mediaMode = mode; },
  });
  const headings = { email: 'FnkWelcomeV2EmailHeading', reward: 'FnkWelcomeV2RewardHeading', phone: 'FnkWelcomeV2PhoneHeading', sent: 'FnkWelcomeV2SentHeading' };

  function save() { if (!preview) { try { localStorage.setItem(key, JSON.stringify(state)); } catch {} } }
  function syncTeaser() {
    dialog.dataset.emailAccepted = String(state.emailAccepted);
    dialog.dataset.smsAccepted = String(state.smsAccepted);
    document.dispatchEvent(new CustomEvent('fnk:welcome-state'));
    if (!teaserRoot) return;
    teaserRoot.hidden = false;
    teaserRoot.dataset.welcomeState = state.smsAccepted ? 'complete' : state.emailAccepted ? 'upgrade' : 'new';
    const copy = offerCopy.teaserCopy(state, teaser.dataset);
    if (teaserLabel) api.renderWelcomeTeaserLabel(teaserLabel, copy.label);
    teaser.setAttribute('aria-label', copy.open);
  }
  function updateResend() {
    if (!resendButton) return;
    const seconds = Math.max(0, Math.ceil((resendDeadline - Date.now()) / 1000));
    resendButton.disabled = busy || !lastSmsEvent || seconds > 0;
    resendButton.textContent = busy ? resendButton.dataset.busy : seconds ? resendButton.dataset.wait.replace('[seconds]', String(seconds)) : resendButton.dataset.idle;
    changePhoneButton.disabled = busy;
    if (!seconds) { clearInterval(resendTimer); resendTimer = undefined; }
  }
  function startResendTimer() {
    clearInterval(resendTimer);
    resendDeadline = Date.now() + 30000;
    updateResend();
    if (dialog.open) resendTimer = setInterval(updateResend, 1000);
  }
  async function applySmsDiscount() {
    if (applyingSmsDiscount) return;
    applyingSmsDiscount = true;
    smsDiscountStatus.textContent = smsDiscountStatus.dataset.applying;
    applySmsButton.hidden = true;
    try {
      const result = await applyWelcomeDiscount('sms');
      offerCopy.update(result.cart);
      smsDiscountStatus.textContent = smsDiscountStatus.dataset[result.state];
      applySmsButton.hidden = result.state !== 'ready';
      document.dispatchEvent(new DiscountUpdateEvent(result.cart, 'fnk-welcome-v2'));
      track(`sms_cart_${result.state}`);
    } catch {
      smsDiscountStatus.textContent = smsDiscountStatus.dataset.error;
      applySmsButton.hidden = false;
      track('sms_cart_failed');
    } finally { applyingSmsDiscount = false; }
  }
  function motion() {
    dialog.classList.toggle('is-paused', paused);
    motionButton.setAttribute('aria-pressed', String(paused));
    motionButton.setAttribute('aria-label', paused ? motionButton.dataset.play : motionButton.dataset.pause);
    motionButton.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
    media.start();
  }
  function show(step, focus = true) {
    dialog.dataset.step = step;
    dialog.querySelectorAll('[data-welcome-step]').forEach(node => { node.hidden = node.dataset.welcomeStep !== step; });
    dialog.querySelectorAll('[data-welcome-progress]').forEach(node => {
      if (node.dataset.welcomeProgress === (step === 'phone' || step === 'sent' ? 'sms' : 'email')) node.setAttribute('aria-current', 'step');
      else node.removeAttribute('aria-current');
    });
    dialog.setAttribute('aria-labelledby', headings[step]);
    dialog.querySelector('[data-welcome-back]').hidden = recovery;
    if (step === 'sent') updateResend();
    dialog.scrollTop = 0;
    motion();
    if (dialog.open) trackStep();
    if (dialog.open && focus) {
      const target = step === 'phone' ? smsForm.elements.phone : dialog.querySelector(`#${headings[step]}`);
      target.focus({ preventScroll: true });
    }
  }
  function trackStep() {
    const step = dialog.dataset.step;
    const event = { email: 'viewed', reward: 'reward_viewed', phone: 'phone_viewed', sent: 'completed_viewed' }[step];
    if (event) track(event, { trigger, step, entry });
  }
  async function open(upgrade = false, source = 'teaser', cartRecovery = false) {
    state = api.restoreWelcomeV2State(state); save(); syncTeaser();
    offerCopy.refresh();
    if (opening || closing) return;
    if (dialog.open) { dialog.querySelector('[data-welcome-close]').focus(); return; }
    opening = true;
    trigger = source;
    recovery = source === 'recovery' || cartRecovery;
    entry = recovery ? 'recovery' : state.emailAccepted ? 'resume' : 'new';
    lastFocused = document.activeElement;
    try {
      const modal = document.querySelector('dialog:modal');
      if (modal) {
        const cart = modal.closest('cart-drawer-component');
        if (!cart?.closeDialog) return;
        returnCart = cart;
        let onPop;
        let timer;
        const settled = history.state?.cartDrawerOpen ? new Promise(resolve => { onPop = () => { clearTimeout(timer); resolve(); }; window.addEventListener('popstate', onPop, { once: true }); timer = setTimeout(resolve, 800); }) : Promise.resolve();
        await cart.closeDialog();
        await settled;
        if (onPop) window.removeEventListener('popstate', onPop);
      }
      show(recovery ? 'phone' : state.smsAccepted ? 'sent' : state.emailAccepted ? upgrade ? 'phone' : 'reward' : 'email', false);
      dialog.showModal();
      shown = true;
      if (!preview) { try { sessionStorage.setItem(`${key}-shown`, 'true'); } catch {} }
      document.body.classList.add('fnk-chain-popup-open');
      dialog.querySelector(`#${headings[dialog.dataset.step]}`).focus({ preventScroll: true });
      trackStep();
      if (state.smsAccepted && !recovery) applySmsDiscount();
      if (recovery) track('recovery_opened', { trigger, entry });
      motion();
    } finally { opening = false; }
  }
  async function close() {
    if (!dialog.open || closing) return;
    closing = true;
    media.stop();
    dialog.close();
    clearInterval(resendTimer);
    lastSmsEvent = undefined; resendEvent = undefined;
    smsForm.elements.phone.value = '';
    document.body.classList.remove('fnk-chain-popup-open');
    state.dismissedAt = Date.now(); save(); track('dismissed');
    if (['email', 'reward', 'phone'].includes(dialog.dataset.step)) track(`dismissed_${dialog.dataset.step}`);
    const cart = returnCart?.isConnected ? returnCart : returnCart ? document.querySelector('cart-drawer-component') : null;
    returnCart = null;
    if (cart?.showDialog) cart.showDialog();
    (teaserRoot?.hidden ? lastFocused : teaser || lastFocused)?.focus({ preventScroll: true });
    closing = false;
  }

  for (const form of [emailForm, smsForm]) form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const channel = form.dataset.welcomeForm;
    const error = form.querySelector('[role="alert"]');
    let input = channel === 'email' ? form.elements.email : form.elements.phone;
    const button = form.querySelector('[type="submit"]');
    error.textContent = ''; input.removeAttribute('aria-invalid');
    let request;
    try {
      if (channel === 'sms' && !state.emailAccepted && !recovery) { show('email'); return; }
      request = api.buildWelcomeV2Request({ companyId: dialog.dataset.companyId, emailList: dialog.dataset.emailList, smsList: dialog.dataset.smsList, channel, email: channel === 'email' ? input.value : email, phone: channel === 'sms' ? input.value : undefined, requestId: channel === 'sms' ? smsRequestId : undefined });
      if (channel === 'sms') {
        const profile = request.rewardEvent.body.data.attributes.profile.data.attributes;
        const identity = JSON.stringify(profile);
        if (identity !== smsIdentity || !smsRequestId) { smsIdentity = identity; smsRequestId = crypto.randomUUID(); }
        request.rewardEvent.body.data.attributes.unique_id = smsRequestId;
      }
    } catch (failure) {
      if (['email', 'phone'].includes(failure.message)) track(channel === 'email' ? 'email_invalid' : 'sms_invalid');
      error.textContent = failure.message === 'email' ? dialog.dataset.emailError : failure.message === 'phone' ? dialog.dataset.phoneError : dialog.dataset.requestError;
      input.setAttribute('aria-invalid', 'true'); input.focus(); return;
    }
    busy = true; button.disabled = true; input.readOnly = true; button.textContent = button.dataset.busy; form.setAttribute('aria-busy', 'true'); track(`${channel}_attempted`);
    try {
      await api.submitWelcomeV2(request);
      if (channel === 'sms') track('sms_subscribed');
      track(`${channel}_accepted`);
      if (channel === 'email') {
        email = request.body.data.attributes.profile.data.attributes.email; state.emailAccepted = true; state.emailAcceptedAt = Date.now(); save(); syncTeaser(); show('reward');
        if (!preview) { try { sessionStorage.setItem(`${key}-email`, JSON.stringify({ email, acceptedAt: Date.now() })); } catch {} }
        applyingEmailDiscount = true;
        api.renderWelcomeEmailDiscount(dialog, null, { applying: true });
        applyWelcomeDiscount('email').then(applied => {
          applyingEmailDiscount = false;
          offerCopy.update(applied.cart);
          api.renderWelcomeEmailDiscount(dialog, applied.cart);
          document.dispatchEvent(new DiscountUpdateEvent(applied.cart, 'fnk-welcome-v2'));
        }).catch(() => {
          applyingEmailDiscount = false;
          api.renderWelcomeEmailDiscount(dialog, null, { failed: true });
        });
      } else {
        lastSmsEvent = request.rewardEvent; resendEvent = undefined;
        const phone = request.body.data.attributes.profile.data.attributes.phone_number;
        const destination = dialog.querySelector('[data-welcome-sent-to]');
        if (destination) destination.textContent = destination.dataset.template.replace('[last4]', phone.slice(-4));
        if (resendStatus) resendStatus.textContent = '';
        state.smsAccepted = true; state.smsAcceptedAt = Date.now(); save(); syncTeaser(); input.value = ''; email = ''; emailForm.elements.email.value = '';
        smsRequestId = undefined; smsIdentity = '';
        try { sessionStorage.removeItem(`${key}-email`); } catch {}
        show('sent'); startResendTimer(); applySmsDiscount();
      }
    } catch (failure) {
      error.textContent = dialog.dataset.requestError;
      if (channel === 'sms' && failure.message === 'reward') { track('sms_subscribed'); track('sms_code_failed'); }
      track(`${channel}_failed`);
    }
    finally { busy = false; button.disabled = false; input.readOnly = false; button.textContent = button.dataset.idle; form.removeAttribute('aria-busy'); updateResend(); }
  });

  applySmsButton.addEventListener('click', applySmsDiscount);
  resendButton?.addEventListener('click', async () => {
    if (busy || !lastSmsEvent || Date.now() < resendDeadline) return;
    resendEvent ||= { ...lastSmsEvent, body: { data: { ...lastSmsEvent.body.data, attributes: { ...lastSmsEvent.body.data.attributes, unique_id: crypto.randomUUID() } } } };
    busy = true; updateResend(); resendStatus.textContent = ''; track('resend_attempted');
    try {
      await api.requestWelcomeV2Code(resendEvent);
      resendEvent = undefined; resendStatus.textContent = resendStatus.dataset.success;
      track('resend_accepted'); startResendTimer();
    } catch { resendStatus.textContent = resendStatus.dataset.error; track('resend_failed'); }
    finally { busy = false; updateResend(); }
  });
  changePhoneButton?.addEventListener('click', () => {
    if (busy) return;
    email = lastSmsEvent?.body.data.attributes.profile.data.attributes.email || '';
    lastSmsEvent = undefined; resendEvent = undefined; smsRequestId = undefined; smsIdentity = '';
    clearInterval(resendTimer); smsForm.elements.phone.value = '';
    smsForm.querySelector('[role="alert"]').textContent = '';
    recovery = true; track('phone_change_clicked'); show('phone');
  });
  document.querySelectorAll('[data-welcome-recovery]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(true, 'recovery'); }));

  document.addEventListener('fnk:welcome-open', event => {
    if (event.detail?.trigger !== 'cart') return;
    if (event.detail.savings) offerCopy.useSavings(event.detail.savings);
    const upgrade = event.detail.upgrade === true || state.emailAccepted;
    track('cart_offer_clicked', { trigger: 'cart', entry: upgrade ? state.emailAccepted ? 'resume' : 'recovery' : 'new' });
    open(upgrade, 'cart', upgrade && !state.emailAccepted);
  });
  document.addEventListener('fnk:welcome-cart-viewed', event => track('cart_offer_viewed', { trigger: 'cart', entry: event.detail?.upgrade ? 'resume' : 'new' }));
  teaser?.addEventListener('click', event => { event.preventDefault(); event.stopImmediatePropagation(); track('teaser_clicked', { entry: state.emailAccepted ? 'resume' : 'new' }); if (state.emailAccepted && !state.smsAccepted) track('upgrade_clicked'); open(state.emailAccepted); }, true);
  for (const form of [emailForm, smsForm]) form.addEventListener('input', () => track(`${form.dataset.welcomeForm}_started`), { once: true });
  dialog.querySelectorAll('a[href*="/collections/best-sellers-1"]').forEach(link => link.addEventListener('click', () => track('shop_clicked', { step: dialog.dataset.step })));
  if (teaser && typeof IntersectionObserver === 'function') {
    const seen = new Set();
    const observer = new IntersectionObserver(entries => {
      const stage = state.emailAccepted ? 'resume' : 'new';
      if (entries.some(item => item.isIntersecting) && !state.smsAccepted && !seen.has(stage)) {
        seen.add(stage); track('teaser_viewed', { entry: stage });
      }
    });
    observer.observe(teaser);
  }
  dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  dialog.querySelector('[data-welcome-upgrade]').addEventListener('click', () => { if (state.emailAccepted) { track('upgrade_clicked'); show('phone'); } });
  dialog.querySelector('[data-welcome-back]').addEventListener('click', () => show('reward'));
  dialog.querySelector('[data-welcome-copy]').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(dialog.dataset.emailCode); track('copied');
      const status = dialog.querySelector('[data-welcome-copy-status]'); status.textContent = dialog.dataset.copied;
      clearTimeout(toastTimer); toastTimer = setTimeout(() => { status.textContent = ''; }, 2200);
    } catch {
      const range = document.createRange(); range.selectNodeContents(dialog.querySelector('[data-welcome-code]'));
      const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
    }
  });
  motionButton.addEventListener('click', () => { paused = !paused; motion(); });
  reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; motion(); });
  document.addEventListener('visibilitychange', motion);
  window.addEventListener('storage', event => {
    if (event.key !== key || !event.newValue) return;
    try { state = api.restoreWelcomeV2State(JSON.parse(event.newValue)); syncTeaser(); } catch {}
  });
  dialog.dataset.ready = 'true';
  syncTeaser();
  if (new URLSearchParams(location.search).get('fnk_sms_code') === '1') open(true, 'recovery');
  else if (preview) open();
  else {
    let autoTimer;
    let timerReady = false;
    const autoOpen = source => {
      state = api.restoreWelcomeV2State(state); syncTeaser();
      if (!canAutoShowWelcome({ accepted: state.emailAccepted || state.smsAccepted, dismissedAt: state.dismissedAt, shownThisSession: shown }) || dialog.open || /\/(cart|checkouts?|account|policies)(\/|$)|\/pages\/contact(?:\/|$)/.test(location.pathname)) return true;
      if (document.hidden || [...document.querySelectorAll('dialog:modal, [aria-modal="true"]')].some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden')) return false;
      clearTimeout(autoTimer);
      open(false, source);
      return true;
    };
    const retryAutoOpen = () => {
      clearTimeout(autoTimer);
      autoTimer = undefined;
      if (!timerReady || autoOpen('timer') || document.hidden) return;
      autoTimer = setTimeout(retryAutoOpen, 1000);
    };
    autoTimer = setTimeout(() => { timerReady = true; retryAutoOpen(); }, api.welcomeV2AutoDelay(performance.now()));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && timerReady) retryAutoOpen();
    });
    window.addEventListener('scroll', () => {
      hasScrolled ||= scrollY > previousY; previousY = scrollY;
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        if (api.welcomeV2ScrollReached({ scrollY, viewportHeight: innerHeight, pageHeight: document.documentElement.scrollHeight, hasScrolled })) autoOpen('scroll');
      });
    }, { passive: true });
  }
}
